module.exports = __webpack_public_path__ + "img/step6-04.2315d0f9.jpg";